var exports = {
  "y": "expandTriangleIcon__wOs0TV",
  "k": "SubIssuesSummaryToken__J-hLRe",
};

module.exports = exports;
